/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ /** @deprecated use the new GQL hook use-opt-ins.ts */ const FETCH_OPT_INS = 'opt-ins/fetch-opt-ins';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const FETCH_OPT_INS_SUCCESS = 'opt-ins/fetch-opt-ins-success';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const FETCH_OPT_INS_FAILED = 'opt-ins/fetch-opt-ins-failed';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const TOGGLE_OPT_INS = 'opt-ins/toggle-opt-ins';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const UPDATE_OPT_INS = 'opt-ins/update-opt-ins';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const UPDATE_OPT_INS_SUCCESS = 'opt-ins/update-opt-ins-success';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const UPDATE_OPT_INS_FAILED = 'opt-ins/update-opt-ins-failed';
/** @deprecated use the new GQL hook use-opt-ins.ts */ const toggleOptIns = (payload)=>({
        type: TOGGLE_OPT_INS,
        payload
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const fetchOptIns = ()=>({
        type: FETCH_OPT_INS
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const fetchOptInsSuccess = (payload)=>({
        type: FETCH_OPT_INS_SUCCESS,
        payload
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const fetchOptInsFailed = (error)=>({
        type: FETCH_OPT_INS_FAILED,
        error
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const updateOptIns = (payload)=>({
        type: UPDATE_OPT_INS,
        payload
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const updateOptInsSuccess = ()=>({
        type: UPDATE_OPT_INS_SUCCESS
    })
;
/** @deprecated use the new GQL hook use-opt-ins.ts */ const updateOptInsFailed = (error)=>({
        type: UPDATE_OPT_INS_FAILED,
        error
    })
;

export { FETCH_OPT_INS, FETCH_OPT_INS_FAILED, FETCH_OPT_INS_SUCCESS, TOGGLE_OPT_INS, UPDATE_OPT_INS, UPDATE_OPT_INS_FAILED, UPDATE_OPT_INS_SUCCESS, fetchOptIns, fetchOptInsFailed, fetchOptInsSuccess, toggleOptIns, updateOptIns, updateOptInsFailed, updateOptInsSuccess };
//# sourceMappingURL=actions.js.map
